export default __webpack_public_path__ + "static/media/Collab7.39bd84f9.png";